import React from 'react';

import { Dot, DotsWrapper, StyledDotIcon } from './LoadingDots.styles';

type Props = {
  height?: string;
};

export const LoadingDots = ({ height }: Props) => {
  const dots = Array(3).fill(null);

  return (
    <DotsWrapper>
      {dots.map((_, index) => (
        <Dot key={index}>
          <StyledDotIcon height={height} />
        </Dot>
      ))}
    </DotsWrapper>
  );
};
